import React, { ReactNode } from 'react';
import { CustomPageLoader, FormLayoutProps, ProtectedContainerProps, getPages as getPagesCore } from 'omni-package-react-core';
import Constants from '../../Constants';

const CommunicationPreferencesFormPage = (props: { documentsDependencies: React.ReactNode[] }) => <CustomPageLoader {...props} loader={() => import('../CommunicationPreferencesFormPage')} />;
const CommunicationPreferencesConfirmationPage = (props: { returnPage: string }) => <CustomPageLoader {...props} loader={() => import('../CommunicationPreferencesConfirmationPage')} />;

const getPages = (
  ProtectedContainer: React.FC<ProtectedContainerProps>,
  isAuthenticated: boolean,
  FormLayout: React.FC<FormLayoutProps>,
  returnPage: string,
  documentsDependencies: ReactNode[],
) => getPagesCore([
  {
    exact: true,
    path: Constants.PreferencesCommunicationChangeSegment,
    component: (
      <FormLayout returnPage={returnPage} name="communication-preferences-form" lob="corpo">
        <CommunicationPreferencesFormPage documentsDependencies={documentsDependencies} />
      </FormLayout>),
    protected: true,
  },
  {
    exact: true,
    path: Constants.PreferencesCommunicationChangeConfirmationSegment,
    component: (
      <FormLayout returnPage={returnPage} name="communication-preferences-confirmation" lob="corpo">
        <CommunicationPreferencesConfirmationPage returnPage={returnPage} />
      </FormLayout>),
    protected: true,
  },
], ProtectedContainer, isAuthenticated, Constants.PreferencesSegment);

export default getPages;
